import { createFileRoute } from '@tanstack/react-router';
import { PartnerDetailPage } from '@/components/partners/PartnerDetailPage';

export const Route = createFileRoute('/_authenticated/partners/$partnerId')({
  component: PartnerDetailRoute,
});

function PartnerDetailRoute() {
  const { partnerId } = Route.useParams();
  return <PartnerDetailPage partnerId={partnerId} />;
}
